module.exports = __webpack_public_path__ + "img/home-points-ecomotive.d3f1a6cc.png";